import { useBoolean } from 'ahooks';
import { Close } from '@mui/icons-material';
import {
  Checkbox,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

export const KoProtocol2 = () => {
  const [open, { setTrue, setFalse }] = useBoolean();
  return (
    <div>
      <FormControlLabel label="[선택] 광고성 정보 이메일 수신 동의" control={<Checkbox />} />

      <FormControlLabel
        label={
          <div>
            [선택] 광고성 목적의 개인정보 수집 및 이용 동의
            <Link
              role="button"
              className="ml-4!"
              onClick={(e) => {
                e.preventDefault();
                setTrue();
              }}
            >
              전문보기
            </Link>
          </div>
        }
        control={<Checkbox />}
      />

      <Dialog open={open} onClose={setFalse} maxWidth="md">
        <DialogTitle className="flex! items-center justify-between">
          [선택사항] 광고 목적으로 개인 정보 수집 및 사용에 대한 동의
          <IconButton aria-label="close" onClick={setFalse}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText className="pb-6">
            회사는 이 웹사이트를 통해 마케팅 및 홍보 서비스를 제공하기 위해 다음과 같은 개인 정보를 수집합니다.
          </DialogContentText>

          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>수집 항목</TableCell>
                  <TableCell>수집 목적</TableCell>
                  <TableCell>보유 기간</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell>이메일 주소(ID), 이름</TableCell>
                  <TableCell className="underline">
                    개인화된 광고를 발송하고 이메일 등의 전자적 전송 매체를 통해 이벤트 및 프로모션에 대한 정보를
                    제공합니다.
                  </TableCell>
                  <TableCell className="underline">동의가 철회되거나 회원 자격이 취소될 때 삭제한다.</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <DialogContentText className="pt-6">
            ※ 귀하는 상기 개인정보의 수집과 사용에 대한 동의를 거부할 수 있지만 동의를 거부하면 마케팅 및 판촉 서비스를
            받을 수 없습니다.
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
};
